import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import sweetalert from "sweetalert";
import ApiEnter from "@/api/ApiEnter";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import PageHeader from "@/components/UI/PageHeader.vue";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import CKEditorConfig from "@/data/CKeditor/config";
import dayjs from "dayjs";
import ApiGasLucePage from "@/api/ApiGasLucePage";
import UtilGeneral from "@/util/Common/UtilGeneral";
import ApiAdmin from "@/api/ApiAdmin";
let EditStaticPage = class EditStaticPage extends Vue {
    constructor() {
        super(...arguments);
        this.Breadcrumbs = [
            {
                to: "/",
                text: "Home"
            },
            {
                to: "/admin/blog",
                text: "CMS",
                disabled: true
            },
            {
                text: "Edit Luce&Gas page",
                disabled: true
            }
        ];
        this.HasLoading = false;
        this.editor = ClassicEditor;
        this.editorConfig = CKEditorConfig.editorStaticPagesConfig(ApiEnter.CurrentSessionUUID);
        this.newData = {
            primary_header_text: "",
            secondary_header_text: "",
            header_img_desktop_url: "",
            header_img_desktop_name: "",
            header_img_mobile_url: "",
            header_img_mobile_name: "",
            luce_offer_pun: "",
            luce_offer_fixed: "",
            luce_offer_fixed_old: "",
            luce_offer_img_url: "",
            luce_offer_img_name: "",
            luce_offer_pdf_url: "",
            luce_offer_pdf_name: "",
            luce_offer_web_pun: "",
            luce_offer_web_fixed: "",
            luce_offer_web_fixed_old: "",
            luce_offer_web_img_url: "",
            luce_offer_web_img_name: "",
            luce_offer_web_pdf_url: "",
            luce_offer_web_pdf_name: "",
            gas_offer_psv: "",
            gas_offer_fixed: "",
            gas_offer_fixed_old: "",
            gas_offer_img_url: "",
            gas_offer_img_name: "",
            gas_offer_pdf_url: "",
            gas_offer_pdf_name: "",
            gas_offer_web_psv: "",
            gas_offer_web_fixed: "",
            gas_offer_web_fixed_old: "",
            gas_offer_web_img_url: "",
            gas_offer_web_img_name: "",
            gas_offer_web_pdf_url: "",
            gas_offer_web_pdf_name: "",
            details_section_text: "",
            before_form_section_text: "",
            form_section_text: "",
            privacy_pdf_url: "",
            privacy_pdf_name: "",
            created_at: "",
            updated_at: ""
        };
    }
    CopyLink(link) {
        UtilGeneral.CopyLink(link);
    }
    CanSubmit() {
        if (this.newData.primary_header_text === '') {
            return false;
        }
        if (this.newData.secondary_header_text === '') {
            return false;
        }
        if (this.newData.header_img_desktop_url === '') {
            return false;
        }
        if (this.newData.header_img_mobile_url === '') {
            return false;
        }
        if (this.newData.luce_offer_pun === '') {
            return false;
        }
        if (this.newData.luce_offer_fixed === '') {
            return false;
        }
        if (this.newData.luce_offer_fixed_old === '') {
            return false;
        }
        if (this.newData.luce_offer_img_url === '') {
            return false;
        }
        if (this.newData.luce_offer_pdf_url === '') {
            return false;
        }
        if (this.newData.gas_offer_psv === '') {
            return false;
        }
        if (this.newData.gas_offer_fixed === '') {
            return false;
        }
        if (this.newData.gas_offer_fixed_old === '') {
            return false;
        }
        if (this.newData.gas_offer_img_url === '') {
            return false;
        }
        if (this.newData.gas_offer_pdf_url === '') {
            return false;
        }
        if (this.newData.details_section_text === '') {
            return false;
        }
        if (this.newData.before_form_section_text === '') {
            return false;
        }
        if (this.newData.form_section_text === '') {
            return false;
        }
        if (this.newData.privacy_pdf_url === '') {
            return false;
        }
        return true;
    }
    async DownloadPhotoSlide(filename) {
        await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, filename).then(response => {
            let a = document.createElement("a");
            let file = new Blob([response]);
            a.href = URL.createObjectURL(file);
            a.download = filename.split("/")[8];
            a.click();
        });
    }
    async UploadHeaderImgDesktop(data) {
        if (this.newData.header_img_desktop_url) {
            data.header_img_desktop_url = await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newData.header_img_desktop_url, this.newData.header_img_desktop_name);
        }
    }
    async UploadHeaderImgMobile(data) {
        if (this.newData.header_img_mobile_url) {
            data.header_img_mobile_url = await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newData.header_img_mobile_url, this.newData.header_img_mobile_name);
        }
    }
    async UploadGasOfferImg(data) {
        if (this.newData.gas_offer_img_url) {
            data.gas_offer_img_url = await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newData.gas_offer_img_url, this.newData.gas_offer_img_name);
        }
    }
    async UploadLuceOfferImg(data) {
        if (this.newData.luce_offer_img_url) {
            data.luce_offer_img_url = await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newData.luce_offer_img_url, this.newData.luce_offer_img_name);
        }
    }
    async UploadGasOfferPdf(data) {
        if (this.newData.gas_offer_pdf_url) {
            data.gas_offer_pdf_url = await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newData.gas_offer_pdf_url, this.newData.gas_offer_pdf_name);
        }
    }
    async UploadLuceOfferPdf(data) {
        if (this.newData.luce_offer_pdf_url) {
            data.luce_offer_pdf_url = await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newData.luce_offer_pdf_url, this.newData.luce_offer_pdf_name);
        }
    }
    async UploadLuceOfferWebImg(data) {
        if (this.newData.luce_offer_web_img_url) {
            data.luce_offer_web_img_url = await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newData.luce_offer_web_img_url, this.newData.luce_offer_web_img_name);
        }
    }
    async UploadLuceOfferWebPdf(data) {
        if (this.newData.luce_offer_web_pdf_url) {
            data.luce_offer_web_pdf_url = await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newData.luce_offer_web_pdf_url, this.newData.luce_offer_web_pdf_name);
        }
    }
    async UploadGasOfferWebImg(data) {
        if (this.newData.gas_offer_web_img_url) {
            data.gas_offer_web_img_url = await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newData.gas_offer_web_img_url, this.newData.gas_offer_web_img_name);
        }
    }
    async UploadGasOfferWebPdf(data) {
        if (this.newData.gas_offer_web_pdf_url) {
            data.gas_offer_web_pdf_url = await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newData.gas_offer_web_pdf_url, this.newData.gas_offer_web_pdf_name);
        }
    }
    async UploadPrivacyPdf(data) {
        if (this.newData.privacy_pdf_url) {
            data.privacy_pdf_url = await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newData.privacy_pdf_url, this.newData.privacy_pdf_name);
        }
    }
    async OnClickSubmit() {
        this.HasLoading = true;
        const data = this.newData;
        await Promise.all([
            this.UploadHeaderImgDesktop(data),
            this.UploadHeaderImgMobile(data),
            this.UploadGasOfferImg(data),
            this.UploadLuceOfferImg(data),
            this.UploadGasOfferPdf(data),
            this.UploadLuceOfferPdf(data),
            this.UploadLuceOfferWebImg(data),
            this.UploadLuceOfferWebPdf(data),
            this.UploadGasOfferWebImg(data),
            this.UploadGasOfferWebPdf(data),
            this.UploadPrivacyPdf(data),
        ]);
        if (ApiEnter.CurrentSessionUUID != undefined) {
            const response = await ApiGasLucePage.UpdateGasLucePage(ApiEnter.CurrentSessionUUID, data);
            if (response) {
                sweetalert({
                    title: this.$t("general.success"),
                    text: this.$t("general.success_created"),
                    icon: "success"
                }).then(() => {
                    this.$router.push(`/`);
                });
            }
            else {
                sweetalert({
                    title: "Error",
                    text: "Error with create Gas&Luce page",
                    icon: "error"
                });
            }
        }
        this.HasLoading = false;
    }
    async DownloadGasOfferImg(response) {
        if (response.gas_offer_img_url) {
            const gasOfferBanner = await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, response.gas_offer_img_url);
            const fileData = new File([
                new Blob([gasOfferBanner.data])
            ], response.gas_offer_img_url.split("/")[8]);
            this.newData.gas_offer_img_url = fileData;
            this.newData.gas_offer_img_name = response.gas_offer_img_url;
        }
    }
    async DownloadLuceOfferImg(response) {
        if (response.luce_offer_img_url) {
            const luceOfferBanner = await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, response.luce_offer_img_url);
            const fileData = new File([
                new Blob([luceOfferBanner.data])
            ], response.luce_offer_img_url.split("/")[8]);
            this.newData.luce_offer_img_url = fileData;
            this.newData.luce_offer_img_name = response.luce_offer_img_url;
        }
    }
    async DownloadGasOfferPdf(response) {
        if (response.gas_offer_pdf_url) {
            const gasOfferPdf = await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, response.gas_offer_pdf_url);
            const fileData = new File([
                new Blob([gasOfferPdf.data])
            ], response.gas_offer_pdf_url.split("/")[8]);
            this.newData.gas_offer_pdf_url = fileData;
            this.newData.gas_offer_pdf_name = response.gas_offer_pdf_url;
        }
    }
    async DownloadLuceOfferPdf(response) {
        if (response.luce_offer_pdf_url) {
            const luceOfferPdf = await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, response.luce_offer_pdf_url);
            const fileData = new File([
                new Blob([luceOfferPdf.data])
            ], response.luce_offer_pdf_url.split("/")[8]);
            this.newData.luce_offer_pdf_url = fileData;
            this.newData.luce_offer_pdf_name = response.luce_offer_pdf_url;
        }
    }
    async DownloadLuceOfferWebImg(response) {
        if (response.luce_offer_web_img_url) {
            const luceOfferWebBanner = await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, response.luce_offer_web_img_url);
            const fileData = new File([
                new Blob([luceOfferWebBanner.data])
            ], response.luce_offer_web_img_url.split("/")[8]);
            this.newData.luce_offer_web_img_url = fileData;
            this.newData.luce_offer_web_img_name = response.luce_offer_web_img_url;
        }
    }
    async DownloadLuceOfferWebPdf(response) {
        if (response.luce_offer_web_pdf_url) {
            const luceOfferWebPdf = await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, response.luce_offer_web_pdf_url);
            const fileData = new File([
                new Blob([luceOfferWebPdf.data])
            ], response.luce_offer_web_pdf_url.split("/")[8]);
            this.newData.luce_offer_web_pdf_url = fileData;
            this.newData.luce_offer_web_pdf_name = response.luce_offer_web_pdf_url;
        }
    }
    async DownloadGasOfferWebImg(response) {
        if (response.gas_offer_web_img_url) {
            const gasOfferWebBanner = await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, response.gas_offer_web_img_url);
            const fileData = new File([
                new Blob([gasOfferWebBanner.data])
            ], response.gas_offer_web_img_url.split("/")[8]);
            this.newData.gas_offer_web_img_url = fileData;
            this.newData.gas_offer_web_img_name = response.gas_offer_web_img_url;
        }
    }
    async DownloadGasOfferWebPdf(response) {
        if (response.gas_offer_web_pdf_url) {
            const gasOfferWebPdf = await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, response.gas_offer_web_pdf_url);
            const fileData = new File([
                new Blob([gasOfferWebPdf.data])
            ], response.gas_offer_web_pdf_url.split("/")[8]);
            this.newData.gas_offer_web_pdf_url = fileData;
            this.newData.gas_offer_web_pdf_name = response.gas_offer_web_pdf_url;
        }
    }
    async DownloadHeaderMobileImg(response) {
        if (response.header_img_mobile_url) {
            const luceOfferBanner = await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, response.header_img_mobile_url);
            const fileData = new File([
                new Blob([luceOfferBanner.data])
            ], response.header_img_mobile_url.split("/")[8]);
            this.newData.header_img_mobile_url = fileData;
            this.newData.header_img_mobile_name = response.header_img_mobile_url;
        }
    }
    async DownloadHeaderDesktopImg(response) {
        if (response.header_img_desktop_url) {
            const luceOfferBanner = await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, response.header_img_desktop_url);
            const fileData = new File([
                new Blob([luceOfferBanner.data])
            ], response.header_img_desktop_url.split("/")[8]);
            this.newData.header_img_desktop_url = fileData;
            this.newData.header_img_desktop_name = response.header_img_desktop_url;
        }
    }
    async DownloadPrivacyPdf(response) {
        if (response.privacy_pdf_url) {
            const privacyPdf = await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, response.privacy_pdf_url);
            const fileData = new File([
                new Blob([privacyPdf.data])
            ], response.privacy_pdf_url.split("/")[8]);
            this.newData.privacy_pdf_url = fileData;
            this.newData.privacy_pdf_name = response.privacy_pdf_url;
        }
    }
    async GetStaticPage() {
        const response = await ApiGasLucePage.GetGasLucePage(ApiEnter.CurrentSessionUUID);
        if (typeof response != "boolean") {
            this.newData = {
                primary_header_text: response.primary_header_text,
                secondary_header_text: response.secondary_header_text,
                header_img_desktop_url: response.header_img_desktop_url,
                header_img_desktop_name: "",
                header_img_mobile_url: response.header_img_mobile_url,
                header_img_mobile_name: "",
                luce_offer_pun: response.luce_offer_pun,
                luce_offer_fixed: response.luce_offer_fixed,
                luce_offer_fixed_old: response.luce_offer_fixed_old,
                luce_offer_img_url: response.luce_offer_img_url,
                luce_offer_img_name: "",
                luce_offer_pdf_url: response.luce_offer_pdf_url,
                luce_offer_pdf_name: "",
                luce_offer_web_pun: response.luce_offer_web_pun,
                luce_offer_web_fixed: response.luce_offer_web_fixed,
                luce_offer_web_fixed_old: response.luce_offer_web_fixed_old,
                luce_offer_web_img_url: response.luce_offer_web_img_url,
                luce_offer_web_img_name: "",
                luce_offer_web_pdf_url: response.luce_offer_web_pdf_url,
                luce_offer_web_pdf_name: "",
                gas_offer_psv: response.gas_offer_psv,
                gas_offer_fixed: response.gas_offer_fixed,
                gas_offer_fixed_old: response.gas_offer_fixed_old,
                gas_offer_img_url: response.gas_offer_img_url,
                gas_offer_img_name: "",
                gas_offer_pdf_url: response.gas_offer_pdf_url,
                gas_offer_pdf_name: "",
                gas_offer_web_psv: response.gas_offer_web_psv,
                gas_offer_web_fixed: response.gas_offer_web_fixed,
                gas_offer_web_fixed_old: response.gas_offer_web_fixed_old,
                gas_offer_web_img_url: response.gas_offer_web_img_url,
                gas_offer_web_img_name: "",
                gas_offer_web_pdf_url: response.gas_offer_web_pdf_url,
                gas_offer_web_pdf_name: "",
                details_section_text: response.details_section_text,
                before_form_section_text: response.before_form_section_text,
                form_section_text: response.form_section_text,
                privacy_pdf_url: response.privacy_pdf_url,
                privacy_pdf_name: "",
                created_at: response.created_at,
                updated_at: response.updated_at
            };
            await Promise.all([
                this.DownloadGasOfferImg(response),
                this.DownloadGasOfferPdf(response),
                this.DownloadLuceOfferImg(response),
                this.DownloadLuceOfferPdf(response),
                this.DownloadLuceOfferWebImg(response),
                this.DownloadLuceOfferWebPdf(response),
                this.DownloadGasOfferWebImg(response),
                this.DownloadGasOfferWebPdf(response),
                this.DownloadHeaderMobileImg(response),
                this.DownloadHeaderDesktopImg(response),
                this.DownloadPrivacyPdf(response)
            ]);
        }
        else {
            sweetalert({
                title: "Error with get Gas&Luce page",
                icon: "error"
            });
        }
    }
    formatDate(item) {
        if (item) {
            return dayjs.tz(item, "Europe/Rome").format("DD.MM.YYYY HH:mm:ss");
        }
        return "";
    }
    created() {
        this.GetStaticPage();
    }
};
EditStaticPage = __decorate([
    Component({
        components: { PageHeader, StandartTemplate, CKEditor }
    })
], EditStaticPage);
export default EditStaticPage;
